import crudHandlers from "./_crud";

export default (state, action) => {
  const { type } = action;
  switch (type) {
    case 'UPDATE_UNIT_TYPE_RATE_RATES':
      return state

    default:
      state = crudHandlers(state, action, 'unit_type_rate')
      return state
  }
}